import { IoIosArrowForward } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { OcurrenceItem } from "../../components/OcurrenceItem";
import { EmptyState } from "../../components/EmptyState";
import { NotificationPermissionModal } from "../../components/NotificationPermissionModal";
import { BannerCarousel } from "../../components/BannerCarousel";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useGetOcurrences } from "@/hooks/useOcurrences";
import { getUserData } from "@/utils/jwt";
import type { Ocurrence } from "@/types/Ocurrence";
import toast from "react-hot-toast";

export const Home = () => {
  const { data: ocurrencesData } = useGetOcurrences({ includeFollowing: true });
  const navigate = useNavigate();

  // Detecta o role do usuário
  const userData = getUserData();
  const isFieldAgent = userData?.role === "AGENT";

  const handleNotificationPermissionGranted = () => {
    toast.success(
      "Notificações ativadas! Você receberá atualizações em tempo real.",
    );
  };

  const handleNotificationPermissionDenied = () => {
    toast(
      "Você pode ativar as notificações a qualquer momento nas configurações.",
      {
        icon: "ℹ️",
        duration: 4000,
      },
    );
  };

  return (
    <div className="bg-[#f5f5f5] min-h-screen pt-[60px] md:pt-[72px] pb-20">
      {/* Modal de permissão de notificações */}
      <NotificationPermissionModal
        onPermissionGranted={handleNotificationPermissionGranted}
        onPermissionDenied={handleNotificationPermissionDenied}
      />

      {/* Carrossel de Banners - Apenas para cidadãos */}
      {!isFieldAgent && (
        <div className="w-full px-4 pt-4">
          <div className="w-full max-w-7xl lg:max-w-full mx-auto">
            <BannerCarousel />
          </div>
        </div>
      )}

      <div className="w-full flex items-center justify-center px-4">
        <div className="w-full max-w-7xl lg:max-w-full mx-auto mt-6 md:mt-8">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h3 className="text-base md:text-lg font-bold text-foreground">
                {isFieldAgent ? "Minhas Ordens de Serviço" : "Minhas Ocorrências"}
              </h3>
              <p className="text-xs md:text-sm text-gray-500 font-normal">
                Acompanhe o status
              </p>
            </div>
            {ocurrencesData?.data && ocurrencesData.data.length > 0 && (
              <div
                onClick={() => navigate("/ocurrences")}
                className="flex gap-1 md:gap-2 items-center justify-center cursor-pointer"
              >
                <span className="font-semibold md:font-bold text-sm md:text-base text-[hsl(var(--primary))] hover:underline transition duration-300 ease-in-out">
                  Ver todas
                </span>
                <IoIosArrowForward className="inline text-[hsl(var(--primary))] text-sm" />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="w-full flex items-center justify-center px-4">
        <div className="w-full max-w-7xl lg:max-w-full mx-auto space-y-3 md:space-y-4 pb-8">
          {ocurrencesData?.data && ocurrencesData.data.length > 0 ? (
            ocurrencesData.data.map((ocurrence: Ocurrence, index: number) => (
              <motion.div
                key={ocurrence.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: 0.1 * index }}
              >
                <OcurrenceItem data={ocurrence} />
              </motion.div>
            ))
          ) : (
            <EmptyState
              icon={
                <IoDocumentTextOutline className="text-3xl md:text-4xl text-gray-400" />
              }
              title="Nenhuma ocorrência encontrada"
              description="Você ainda não reportou nenhum problema. Comece agora e ajude a melhorar sua cidade!"
              actionButton={<></>}
            />
          )}
        </div>
      </div>
    </div>
  );
};
